import { graphql, useStaticQuery } from "gatsby"
import {
  filterDataByLanguage,
  getRichTextData,
  getFaq,
  getAssetData
} from "./serviceHelpers"

export const useFaqSchoolData = lang => {
  const { allKontentItemSchoolComponent } = useStaticQuery(
    graphql`
      query FaqSchoolQuery {
        allKontentItemSchoolComponent {
          nodes {
            preferred_language
            elements {
              faq_bullet_point {
                value {
                  url
                }
              }
              faq_header {
                resolvedData {
                  html
                }
              }
              faq_points {
                linked_items {
                  elements {
                    faq_question {
                      value
                    }
                    faq_answer_rich_text{
                      resolvedData {
                        html
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  )

  const QueryData = filterDataByLanguage(allKontentItemSchoolComponent, lang)

  let returnData = {
    header: getRichTextData(QueryData.faq_header),
    faqPoints: getFaq(QueryData.faq_points),
    bulletPoint: getAssetData(QueryData.faq_bullet_point)
  }

  return returnData
}
